import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { URLENTITIES } from '../../data/urlEntities';
import { UrlEntitiesModel } from '../../models/urlEntitiesModel';

@Component({
  selector: 'app-header-component',
  templateUrl: './header-component.component.html',
  styleUrls: ['./header-component.component.scss'],
})
export class HeaderComponentComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() entities: string[] = [];
  @Input() urlRepository: string;

  public idTitle = '';
  public entitiesList: UrlEntitiesModel[] = URLENTITIES;

  constructor(private titleHeader: Title) {}

  ngOnInit(): void {
    const title = this.title.toLowerCase().replace(/ /g, '-');
    this.removeAccents(title);
    this.titleHeader.setTitle(this.title);
  }

  removeAccents(str: string): void {
    this.idTitle = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  exist(entitieName: string): boolean {
    return this.entities.find((e: string) => e === entitieName) != null;
  }
}
